// components/ProfessionalHeader.js
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './ProfessionalHeader.css';

const ProfessionalHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const mobileToggleRef = useRef(null);
  const location = useLocation();
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  // Treat the mobile drawer like a modal surface: prevent background scroll
  // and let keyboard users dismiss it without hunting for the toggle again.
  useEffect(() => {
    if (!mobileMenuOpen) {
      document.body.classList.remove('comtel-nav-open');
      return undefined;
    }

    document.body.classList.add('comtel-nav-open');

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setMobileMenuOpen(false);
        mobileToggleRef.current?.focus();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.classList.remove('comtel-nav-open');
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [mobileMenuOpen]);

  const isHomePage = location.pathname === '/';
  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/financial-solutions', label: 'Financial Solutions' },
    { path: '/security-services', label: 'Security' },
    { path: '/about', label: 'About' },
    { path: '/resources', label: 'Resources' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <header className={`professional-header ${scrolled ? 'scrolled' : ''} ${isHomePage ? 'home-page' : 'inner-page'}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">
              <img src="/assets/images/comtel-logo-darkmode.png" alt="Comtel Infosystems" />
            </Link>
          </div>
          
          <nav
            id="primary-navigation"
            className={`main-navigation ${mobileMenuOpen ? 'mobile-open' : ''}`}
            aria-label="Primary navigation"
          >
            <ul>
              {navLinks.map(({ path, label }) => {
                const isActive = location.pathname === path;
                return (
                  <li key={path} className={isActive ? 'active' : ''}>
                    <Link to={path} aria-current={isActive ? 'page' : undefined}>
                      {label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
          
          <div className="header-actions">
            <button 
              className={`mobile-toggle ${mobileMenuOpen ? 'active' : ''}`}
              ref={mobileToggleRef}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label={mobileMenuOpen ? 'Close primary navigation' : 'Open primary navigation'}
              aria-controls="primary-navigation"
              aria-expanded={mobileMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ProfessionalHeader;